/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'left': {
    width: 16,
    height: 16,
    viewBox: '0 0 14.3 23.189',
    data: '<defs/><g id="left" transform="translate(-99.549 -3229)"><path pid="0" id="path" class="cls-1" d="M318 877.705l-8.889 8.89 8.889 8.889-2.706 2.706-11.594-11.595L315.295 875z" transform="translate(-204.151 2354)"/></g>'
  }
})
